export default __webpack_public_path__ + "static/su-ukraina--secondary-1460ad559e7725bab96ea373d010a290.svg";